import React from 'react';
import PropTypes from 'prop-types';
import StyledSvg from '../styledSvg';

const IconMalette = ({ color, size }) => (
  <StyledSvg fill={color} size={size} viewBox="0 0 54 48" xmlns="http://www.w3.org/2000/svg">
    <g stroke="#B68962" strokeWidth="2" fill="none" fillRule="evenodd">
      <rect x="1" y="10" width="52" height="37" rx="2" />
      <rect x="18" y="1" width="18" height="9" rx="2" />
      <path d="M27 22v13M20.5 28.5h13" strokeLinecap="square" />
    </g>
  </StyledSvg>
);

IconMalette.propTypes = {
  /** Should be a valid css color in a string */
  color: PropTypes.string,
  /** Should be a the value in px */
  size: PropTypes.number,
};

IconMalette.defaultProps = {
  color: '#000',
  size: 50,
};

export default IconMalette;



// WEBPACK FOOTER //
// ./src/app/components/icons/IconMalette.jsx